<header class="page-header hidden-for-modal">
  <div class="header-left">
    <od-logo></od-logo>
  </div>
  <div class="page-title text-l-bold">{{ pageTitle }}</div>
  <div class="header-right"></div>
</header>
